import type { PlanField } from "../../../api/academyEnrolments/enrolmentsService";

export function sortAvailablePaymentFrequencies(
  keys: string[],
  planFields: PlanField[]
): string[] {
  const orderByKey = new Map(planFields.map((field) => [field.feeKey, field.order]));
  return [...keys].sort(
    (a, b) => (orderByKey.get(a) ?? Infinity) - (orderByKey.get(b) ?? Infinity)
  );
}
